import { Box } from '@mui/material';

export function LoanFlowChrome({ children }: { children: React.ReactNode }) {
  return (
    <Box component="main" className="taste-rise" sx={{ minHeight: '60vh' }}>
      {children}
    </Box>
  );
}
